import {Component, inject} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { VcsService } from '../../../services/vcs.service';
import { BaseComponent } from '../../../../components/base/base.component';
import { VcsAPIService } from '../../../services/vcs-api/vcs-api.service';
import { WmsDialogComponent } from '../../../../components/wms-dialog/wms-dialog.component';
import { WmsDialogHeaderComponent } from '../../../../components/wms-dialog-header/wms-dialog-header.component';
import { WmsDialogBodyComponent } from '../../../../components/wms-dialog-body/wms-dialog-body.component';
import { WmsDialogFooterComponent } from '../../../../components/wms-dialog-footer/wms-dialog-footer.component';
import { showMsg } from '@wms/app/vcs/utils/vcs-utils';
import { WmsMessageComponent } from '../../../../components/wms-message/wms-message.component';
import {replace, runtimeEventManager} from "@wm/core";
import { DialogService } from "@wms/services";
import {isEmpty} from "lodash-es";

@Component({
  selector: 'wms-vcs-push-dialog',
  templateUrl: './wms-vcs-push-dialog.component.html',
  styleUrls: ['./wms-vcs-push-dialog.component.less'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    WmsDialogComponent,
    WmsDialogHeaderComponent,
    WmsDialogBodyComponent,
    WmsDialogFooterComponent,
    WmsMessageComponent
  ],
})
export class WmsVcsPushDialogComponent extends BaseComponent {
  public vcsService: VcsService;
  private vcsAPIService: VcsAPIService;
  dialogService: DialogService;

  protected projectDetails: any;

  constructor() {
    super();
    this.vcsService = inject(VcsService);
    this.vcsAPIService = inject(VcsAPIService);
    this.projectDetails = this.projectService.getDetails();
    this.dialogService = inject( DialogService);
  }

  pushProjectChanges(){
    let vcsParams:any={}
    if (!isEmpty(this.vcsService.pushChangesInfo.defaultCommitMsg)&& !this.vcsService.pushChangesInfo.commitMsg) {
     this.vcsService.msgData = showMsg(this.locale['MESSAGE_WARN_VCS_COMMIT_EMPTY'], 'error');
    } else {
      this.vcsService.isDisablePushBtn = true;
       vcsParams.commitMessagePrefix = this.vcsService.pushChangesInfo.commitMsg;
       vcsParams.migrationCommitMessagePrefix = this.vcsService.pushChangesInfo.migrationCommitMsg;
       vcsParams.migrationCommitEnabled = this.projectService.teamProjectObject.vcsAccountDTO.migrationCommitEnabled
      this.vcsService.msgData = showMsg(this.locale['MESSAGE_VCS_PUSHING'], 'loading');
      this.pushProject(vcsParams);
    }
  }

  pushProject(vcsParams: any) {
    this.vcsService.isActionDisabled = true;
    (this.vcsAPIService.pushChanges(vcsParams) as Promise<any>)
      .then((response) => {
        this.vcsService.msgData = showMsg(this.locale.MESSAGE_VCS_PUSH_SUCCESS.replace("${0}" , response.pushBranchName), 'success');
        setTimeout(() => {
          this.vcsService.hasVCSChanges = false
          this.vcsService.isActionDisabled = false;
          if(this.vcsService.exportProjectasShellDialog){
            this.eventManager.emitExportProjectAsShell()
          }
          if(response.pushedToDevBranch && !(this.vcsService.exportProjectasShellDialog || this.vcsService.externalRepoEnable)) {
            this.dialogService.open('createMRModal', response);
          }
          this.vcsService.isDisablePushBtn  = false;
          if(this.vcsService.externalRepoEnable){
            this.vcsService.vcsBranchName = 'master'
            this.vcsService.selectVCSProvider()
            this.vcsService.openDialogWithId('pushToExternalVCSModal');
            this.vcsService.externalRepoEnable = false
          }
          if(this.vcsService.pushActionCB) {
            this.vcsService.pushActionCB();
          }
          this.closeDialog();
        }, 2000);
      }, (error: any) => {
        let errorObject = error.error.errors.error[0],
            errorMessage:any =  replace(errorObject['message'], errorObject['parameters'], true)
        this.vcsService.isActionDisabled = false;
        this.vcsService.isDisablePushBtn  = true;
        if (errorObject.messageKey === 'VCS_AUTHENTICATION_FAILED') {
          this.vcsService.showUserVCSCredentialsDialog(vcsParams, errorMessage);
        } else {
          this.vcsService.msgData = showMsg(errorMessage, 'error');
        }
      });
  }

  closeDialog() {
    this.vcsService.closeDialogWithId('pushChangesModal');
    this.vcsService.pushActionCB = () => {};
  }

  protected readonly isEmpty = isEmpty;
}
